import { Box, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import { CollapseButton } from '../../../UI/CollapseButton/CollapseButton'
import { usePutAway } from '../../Context/usePutAway'
import { DetailsDocsMatchPutAway } from './DetailsDocsMatchPutAway'
import { putAwayActions } from '../../actions/putAwayActions'
import { putAwayActions as putAwayBusiness } from '../../actions/putAwayBusiness'
import { WorkOrderInBoundLocate } from '../../../../interfaces/WorkOrder/WorkOrder'
import StepBackPutAway from '../StepBackPutAway/StepBackPutAway'
import { useStyles } from './styles'
import { stepperTypes } from '../../types/stepperTypes'
import { useConfiguration } from '../../../../hooks/useConfiguration'
import LockIcon from '@mui/icons-material/Lock'
import { LpnState } from '../../types/enums'
import { eLpnState } from '../../../../enums/eLpnState'

export const DocsMatchPutAway = () => {
  const classes = useStyles()
  const { state, dispatch } = usePutAway()
  const { setItem, setStep, mapperSearchOptions } = putAwayActions()
  const { getWorkOrderLocateUnknown, findWorkingLpn } = putAwayBusiness()
  const { workOrderInboundLocate, searchValue } = state
  const { configurationState, getConfiguration } = useConfiguration()
  const [twoUserSameLPN, setTwoUserSameLPN] = useState(true)
  const handleCollapseClick = (workOrderInbound: WorkOrderInBoundLocate) => {
    dispatch(setItem(workOrderInbound))
    if (
      workOrderInbound.lpn.length > 1 ||
      (workOrderInbound.lpn.length === 1 &&
        workOrderInbound.lpn[0].lpnStateId === eLpnState.Manage)
    ) {
      dispatch(setStep(stepperTypes.stepLPNSelection))
      return
    }
    dispatch(setStep(stepperTypes.stepDescriptionPutAway))
  }

  const handleCollapseUnknownClick = (
    workOrderInbound: WorkOrderInBoundLocate
  ) => {
    getWorkOrderLocateUnknown(workOrderInbound.workOrderId)
  }

  const generateTitle = () => {
    const typeOfSearch = mapperSearchOptions() // obtiene si estamos buscando por LPN o ASN
    switch (typeOfSearch) {
      case 'LPN':
        return `Se encontraron ${workOrderInboundLocate.length} ASN para el LPN ${searchValue}.`
      case 'ASN':
        return `El sistema reconoce ${workOrderInboundLocate.length} ASN con el ID ${searchValue}.`
      default:
        return ''
    }
  }

  useEffect(() => {
    if (configurationState === undefined) {
      getConfiguration()
    } else {
      const externalCourierLabelConfiguration =
        configurationState.configuration.filter(
          (el) => el.name === 'AllowTwoUserOnTheSameLPN'
        )[0]

      if (externalCourierLabelConfiguration !== undefined) {
        setTwoUserSameLPN(externalCourierLabelConfiguration.value === 'true')
      }
    }
  }, [configurationState])

  const validateShowButton = (workOrderInbound: WorkOrderInBoundLocate) => {
    // En caso que la configuración tenga bloqueo por Lpn
    if (!twoUserSameLPN) {
      // en caso que retorne solo 1 lpn y 1 lpn bloqueado se compara para bloquear el boton
      if (
        workOrderInbound.lpn.length === 1 &&
        workOrderInbound.lpnBloqued.length === 1 &&
        findWorkingLpn()?.lpn === workOrderInbound.lpnBloqued[0]
      ) {
        return false
      }
    }

    // en caso que tenga solo 1 lpn valida que no esté en estado "finalizado" o "por gestionar"
    if (
      workOrderInbound &&
      workOrderInbound.lpn &&
      workOrderInbound.lpn.length === 1
    ) {
      if (
        findWorkingLpn()?.lpnStateId === LpnState.Finished ||
        findWorkingLpn()?.lpnStateId === LpnState.Manage
      ) {
        return false
      }
    }

    return true
  }

  // retorna con icono dependiendo de la configuración.
  const headerComponent = (workOrderInbound: WorkOrderInBoundLocate) => {
    if (twoUserSameLPN) return workOrderInbound.asnNumber

    // realiza validación si debe mostrar el icono de candado en el titulo, en caso de estar bloqueado.
    return (
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {workOrderInbound.asnNumber}{' '}
        {!validateShowButton(workOrderInbound) && <LockIcon />}
      </Box>
    )
  }

  if (workOrderInboundLocate.length > 0) {
    return (
      <div className={classes.flexContainer}>
        <StepBackPutAway />
        <Box
          component='div'
          display='flex'
          flexDirection='column'
          flexWrap='nowrap'
          alignItems='center'
          padding='10px 20px 0 20px'
        >
          {state.isUnknownScreen && (
            <Typography
              component='p'
              style={{
                fontSize: '20px',
                marginTop: '30px'
              }}
            >
              {state.titlteDocsMatch}
            </Typography>
          )}
          {!state.isUnknownScreen && (
            <React.Fragment>
              <Typography
                component='p'
                style={{
                  fontSize: '20px',
                  marginTop: '30px'
                }}
              >
                {generateTitle()}
              </Typography>
              <Typography
                component='p'
                variant='h5'
                style={{
                  fontSize: '20px',
                  marginBottom: '30px'
                }}
              >{`¿Cuál desea trabajar?`}</Typography>
            </React.Fragment>
          )}
          {!twoUserSameLPN && (
            <Typography
              component='p'
              style={{
                fontSize: '20px'
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LockIcon />
                LPN está siendo trabajada por otro usuario
              </Box>
            </Typography>
          )}
        </Box>
        <Box
          component='div'
          display='flex'
          flexDirection='column'
          flexWrap='nowrap'
          alignItems='center'
          padding='10px 17px 0 10px'
          className={classes.container}
        >
          {workOrderInboundLocate.map((workOrderInbound) => (
            <CollapseButton
              header={headerComponent(workOrderInbound)}
              handleClick={() =>
                state.isUnknownScreen
                  ? handleCollapseUnknownClick(workOrderInbound)
                  : handleCollapseClick(workOrderInbound)
              }
              showButton={validateShowButton(workOrderInbound)}
              width={'85%'}
            >
              <DetailsDocsMatchPutAway
                workOrderInboundLocate={workOrderInbound}
              />
            </CollapseButton>
          ))}
        </Box>
      </div>
    )
  }

  return <Fragment />
}
